import { render, staticRenderFns } from "./error_icon.vue?vue&type=template&id=469d82f7&"
import script from "./error_icon.vue?vue&type=script&lang=js&"
export * from "./error_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports